<template>
  <div class="index-vue">
    <aside :class="asideClassName">
      <div class="logo-c">
        <img
          v-show="isShowAsideTitle"
          style="width: 140px"
          src="../assets/imgs/e91c6387934650142a7491161cd3741.png"
          alt="logo"
          class="logo"
        />
      </div>
      <Menu
        class="menu"
        ref="asideMenu"
        theme="dark"
        width="100%"
        @on-select="gotoPage"
        accordion
        :open-names="openMenus"
        :active-name="currentPage"
        @on-open-change="menuChange"
      >
        <div v-for="(item, index) in menuItems" :key="index">
          <Submenu v-if="item.children" :name="index">
            <template slot="title">
              <span style="font-size: 14px" v-show="isShowAsideTitle">
                {{
                item.text
                }}
              </span>
            </template>
            <div v-for="(subItem, i) in item.children" :key="index + i">
              <Submenu v-if="subItem.children" :name="index + '-' + i">
                <template slot="title">
                  <span style="font-size: 14px" v-show="isShowAsideTitle">
                    {{
                    subItem.text
                    }}
                  </span>
                </template>
                <MenuItem
                  class="menu-level-3"
                  v-for="(threeItem, k) in subItem.children"
                  v-if="!threeItem.hidden"
                  :name="threeItem.name"
                  :key="index + i + k"
                >
                  <span style="font-size: 14px" v-show="isShowAsideTitle">
                    {{
                    threeItem.text
                    }}
                  </span>
                </MenuItem>
              </Submenu>
              <MenuItem v-else-if="!subItem.hidden" :name="subItem.name">
                <span style="font-size: 14px" v-show="isShowAsideTitle">
                  {{
                  subItem.text
                  }}
                </span>
              </MenuItem>
            </div>
          </Submenu>
          <MenuItem v-else-if="!item.hidden" :name="item.name">
            <span style="font-size: 14px" v-show="isShowAsideTitle">
              {{
              item.text
              }}
            </span>
          </MenuItem>
        </div>
      </Menu>
    </aside>
    <section class="sec-right">
      <div class="top-c">
        <header style="background: #050518; height: 68px">
          <div class="h-left">
            <div class="pointer" @click="isShrinkAside" title="收缩/展开">
              <Icon type="ios-apps" />
            </div>
            <p class="crumbs" style="font-size: 16px">{{ crumbs }}</p>
          </div>
          <div class="h-right">
            <Dropdown trigger="click" @on-click="userOperate" @on-visible-change="showArrow">
              <div class="pointer">
                <span style="font-size: 16px">{{ role }}</span>
                <span style="font-size: 16px">{{ userName }}</span>
                <Icon v-show="arrowDown" type="md-arrow-dropdown" />
                <Icon v-show="arrowUp" type="md-arrow-dropup" />
              </div>
              <DropdownMenu slot="list">
                <DropdownItem name="1">修改密码</DropdownItem>
                <DropdownItem divided name="3">退出登陆</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </header>
      </div>
      <div class="main-content">
        <div class="view-c">
          <keep-alive :include="keepAliveData">
            <router-view v-if="isShowRouter" />
          </keep-alive>
          <div class="loading-c" v-show="showLoading">
            <Spin size="large"></Spin>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { resetTokenAndClearUser } from "../utils";
import { api } from "../biz/api";
export default {
  name: "index",
  data() {
    return {
      paths: {},
      menuItems: [],
      currentPage: "",
      openMenus: [],
      menuCache: [],
      showLoading: false,
      hasNewMsg: true,
      isShowRouter: true,
      role: localStorage.getItem("role"),
      groupName: localStorage.getItem("groupName") || "卡鱼后台管理系统",
      msgNum: "10",
      tagsArry: [],
      arrowUp: false,
      arrowDown: true,
      isShowAsideTitle: true,
      main: null,
      asideClassName: "aside-big",
      asideArrowIcons: [],
      crumbs: "",
      userName: "",
      userImg: ""
    };
  },
  created() {
    this.$axios.interceptors.request.use(
      config => {
        this.showLoading = true;
        return config;
      },
      error => {
        this.showLoading = false;
        return Promise.reject(error);
      }
    );
    this.$axios.interceptors.response.use(
      response => {
        this.showLoading = false;
        const res = response.data;
        return res;
      },
      error => {
        this.showLoading = false;
        return Promise.reject(error);
      }
    );
  },
  async mounted() {
    const res = await api.UsrTree();
    this.menuItems = [];
    res.body.data.forEach(element1 => {
      this.menuItems.push({
        name: element1.targetUrl,
        size: 18,
        type: "md-home",
        text: element1.name
      });
    });
    this.$router.push({ path: this.menuItems[0].name || "/" });
    const name = this.$route.name;
    this.currentPage = name;
    this.tagsArry.push({
      text: this.nameToTitle[name],
      name: name
    });
    this.openMenus = this.getMenus(name);
    this.$nextTick(() => {
      this.$refs.asideMenu.updateOpened();
    });
    this.userName = localStorage.getItem("userName");
    this.userImg = localStorage.getItem("userImg");
    this.main = document.querySelector(".sec-right");
    this.asideArrowIcons = document.querySelectorAll(
      "aside .ivu-icon-ios-arrow-down"
    );
    this.monitorWindowSize();
  },
  watch: {
    $route(to) {
      const name = to.name;
      this.currentPage = name;
      if (name == "error") {
        this.crumbs = "404";
        return;
      }
      if (!this.keepAliveData.includes(name)) {
        if (this.tagsArry.length == 8) {
          this.tagsArry.shift();
        }
        this.tagsArry.push({ name, text: this.nameToTitle[name] });
      }
      setTimeout(() => {
        this.crumbs = this.paths[name];
      }, 0);
    }
  },
  computed: {
    keepAliveData() {
      return this.tagsArry.map(item => item.name);
    },
    nameToTitle() {
      const obj = {};
      this.menuItems.forEach(e => {
        this.processNameToTitle(obj, e);
      });
      return obj;
    }
  },
  methods: {
    getMenus(name) {
      let menus;
      const tagTitle = this.nameToTitle[name];
      for (let i = 0, l = this.menuItems.length; i < l; i++) {
        const item = this.menuItems[i];
        menus = [];
        menus[0] = i;
        if (item.text == tagTitle) {
          return menus;
        }
        if (item.children) {
          for (let j = 0, ll = item.children.length; j < ll; j++) {
            const child = item.children[j];
            menus[1] = i + "-" + j;
            menus.length = 2;
            if (child.text == tagTitle) {
              return menus;
            }
            if (child.children) {
              for (let k = 0, lll = child.children.length; k < lll; k++) {
                const grandson = child.children[k];
                menus[2] = i + "-" + j + "-" + k;
                if (grandson.text == tagTitle) {
                  return menus;
                }
              }
            }
          }
        }
      }
    },
    monitorWindowSize() {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      if (w < 1300) {
        this.shrinkAside();
      }
      window.onresize = () => {
        if (
          w < 1300 &&
          this.isShowAsideTitle &&
          w >
            (document.documentElement.clientWidth || document.body.clientWidth)
        ) {
          this.shrinkAside();
        }
        w = document.documentElement.clientWidth || document.body.clientWidth;
      };
    },
    isActive(name) {
      return this.$route.name === name;
    },
    gotoPage(name, params) {
      this.currentPage = name;
      this.crumbs = this.paths[name];
      this.$router.replace({ name, params });
      if (!this.keepAliveData.includes(name)) {
        if (this.tagsArry.length == 8) {
          this.tagsArry.shift();
        }
        this.tagsArry.push({ name, text: this.nameToTitle[name] });
      }
    },
    userOperate(name) {
      switch (name) {
        case "1":
          this.gotoPage("Config");
          break;
        case "2":
          this.gotoPage("userinfo");
          break;
        case "3":
          resetTokenAndClearUser();
          api.V1loVgout().then(res => {
            this.$router.replace({ name: "login" });
          });
          break;
      }
    },
    showArrow(flag) {
      this.arrowUp = flag;
      this.arrowDown = !flag;
    },
    isShrinkAside() {
      this.isShowAsideTitle ? this.shrinkAside() : this.expandAside();
    },
    shrinkAside() {
      this.asideArrowIcons.forEach(e => {
        e.style.display = "none";
      });
      this.isShowAsideTitle = false;
      this.openMenus = [];
      this.$nextTick(() => {
        this.$refs.asideMenu.updateOpened();
      });
      setTimeout(() => {
        this.asideClassName = "";
        this.main.style.width = "calc(100% - 80px)";
      }, 0);
    },
    expandAside() {
      setTimeout(() => {
        this.isShowAsideTitle = true;
        this.asideArrowIcons.forEach(e => {
          e.style.display = "block";
        });
        this.openMenus = this.menuCache;
        this.$nextTick(() => {
          this.$refs.asideMenu.updateOpened();
        });
      }, 200);
      this.asideClassName = "aside-big";
      this.main.style.width = "calc(100% - 220px)";
    },
    reloadPage() {
      let name = this.$route.name;
      let index = this.keepAliveData.indexOf(name);
      this.$nextTick(() => {
        if (this.tagsArry.length) {
          this.isShowRouter = false;
          this.tagsArry.splice(index, 1);
          this.$nextTick(() => {
            this.tagsArry.splice(index, 0, {
              name,
              text: this.nameToTitle[name]
            });
            this.gotoPage(name);
            this.isShowRouter = true;
          });
        } else {
          this.isShowRouter = false;
          this.$nextTick(() => {
            this.tagsArry.push({ name, text: this.nameToTitle[name] });
            this.gotoPage(name);
            this.isShowRouter = true;
          });
        }
      });
    },
    closeTag(i) {
      let name = this.tagsArry[i].name;
      this.tagsArry.splice(i, 1);
      event.stopPropagation();
      if (this.tagsArry.length) {
        if (this.isActive(name)) {
          if (i != 0) {
            this.gotoPage(this.tagsArry[i - 1].name);
          } else {
            this.gotoPage(this.tagsArry[i].name);
          }
        }
      } else {
        if (name != "home") {
          this.gotoPage("home");
        } else {
          this.reloadPage();
        }
      }
    },
    closeName(name) {
      for (let i = 0, len = this.tagsArry.length; i < len; i++) {
        if (this.tagsArry[i].name == name) {
          this.closeTag(i);
          break;
        }
      }
    },
    closeTags(flag) {
      if (flag == 1) {
        this.tagsArry = [];
        this.gotoPage(this.$route.name);
      } else {
        this.tagsArry = [];
        this.gotoPage("home");
        this.reloadPage();
      }
    },
    activeTag(i) {
      this.gotoPage(this.tagsArry[i].name);
    },
    info() {
      const self = this;
      this.$Notice.info({
        title: `您有${this.msgNum}条消息`,
        render(h) {
          return h(
            "Button",
            {
              attrs: {
                type: "info",
                size: "small"
              },
              on: {
                click() {
                  self.gotoPage("msg");
                  (self.hasNewMsg = false), (self.msgNum = 0);
                }
              }
            },
            ["点击查看"]
          );
        }
      });
    },
    menuChange(data) {
      this.menuCache = data;
    },
    processNameToTitle(obj, data, text) {
      if (data.name) {
        obj[data.name] = data.text;
        this.paths[data.name] = text ? `${text} / ${data.text}` : data.text;
      }
      if (data.children) {
        data.children.forEach(e => {
          this.processNameToTitle(
            obj,
            e,
            text ? `${text} / ${data.text}` : data.text
          );
        });
      }
    }
  }
};
</script>
<style scoped>
.index-vue {
  height: 100%;
  display: flex;
  justify-content: space-between;
  color: #666;
}
aside {
  min-width: 80px;
  background: #050518;
  height: 100%;
  transition: all 0.5s;
  overflow: auto;
}
.logo-c {
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin: 20px 0;
  justify-content: center;
}
.logo {
  width: 40px;
  margin-right: 10px;
}
.aside-big {
  min-width: 220px;
}
.sec-right {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  transition: width 0.5s;
  overflow: auto;
}
.top-c {
  background: rgba(230, 230, 230, 0.5);
  width: 100%;
}
header {
  height: 50px;
  border-bottom: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 40px;
  padding-left: 10px;
  font-size: 14px;
}
header .ivu-icon {
  font-size: 24px;
}
.refresh-c {
  margin: 0 30px;
  cursor: pointer;
}
.h-right {
  display: flex;
  align-items: center;
}
.h-left {
  display: flex;
  align-items: center;
}
.user-img-c img {
  width: 100%;
}
.notice-c {
  cursor: pointer;
  position: relative;
}
.newMsg {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff5722;
  right: 0;
  top: 0;
}
.user-img-c {
  width: 34px;
  height: 34px;
  background: #ddd;
  border-radius: 50%;
  margin: 0 40px;
  overflow: hidden;
}
.tag-options {
  cursor: pointer;
  position: relative;
}
.div-tags {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.div-icons {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #fff;
  height: 33px;
  width: 160px;
  font-size: 14px;
}
.ul-c {
  height: 34px;
  margin-top: 2px;
  background: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px;
  overflow: hidden;
  width: calc(100% - 160px);
}
.ul-c li {
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  height: 24px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 3px 5px 2px 3px;
  border: 1px solid #e6e6e6;
}
a {
  color: #666;
  transition: none;
}
.li-a {
  max-width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ul-c .ivu-icon {
  margin-left: 6px;
}
.active {
  background: #409eff;
  border: 1px solid #409eff;
}
.active a {
  color: #fff;
}
.active .ivu-icon {
  color: #fff;
}
.main-content {
  overflow: auto;
  height: 100%;
  width: 100%;
  background: #eee;
  padding: 10px 12px;
}
.view-c {
  position: relative;
  background: #fff;
  padding: 15px;
}
.pointer {
  cursor: pointer;
}
.loading-c {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.mask {
  position: fixed;
  background: #eee;
  height: 10px;
  width: 100%;
  top: 85px;
  z-index: 10;
}
.crumbs {
  margin-left: 10px;
  color: #97a8be;
  cursor: default;
}
.menu-level-3 .ivu-icon {
  font-size: 14px;
}
.menu {
  background: none !important;
}
</style>